import '@troyes/scss/app-front-page.scss';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/modal';
import Ux from '@troyes/js/services/ux';
import Form from '@troyes/js/services/form';
import Slider from '@troyes/js/services/slider';
import FrontPage from '@troyes/js/services/front-page';

document.addEventListener( "DOMContentLoaded", function () {
    new Ux();
    new Form();
    new Slider();
    new FrontPage();
} );
